import { breakpoints } from '../utils/breakpoints'
import { useMediaQuery } from './useMediaQuery'

export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${breakpoints.tablet - 1}px)`)
